document.addEventListener("DOMContentLoaded", () => {
  const faders = document.querySelectorAll(".fade-in");

  const appearOnScroll = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      // só dispara se a seção entrou na tela E o usuário já rolou a página
      if (entry.isIntersecting && window.scrollY > 50) {
        entry.target.classList.add("appear");
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  faders.forEach(fader => {
    appearOnScroll.observe(fader);
  });
});
